export const MAX_MESSAGE_LENGTH = 160

export const MULTIMEDIA_MESSAGE_MAX_ATTACHMENTS_COUNT = 10
export const MULTIMEDIA_MESSAGE_MAX_ATTACHMENTS_SIZE = 5 * 1024 * 1024 - 5 * 1024
